import { useEffect, useState } from 'react';
import {
	TipAndTrickPageTypeEnum,
	TipsAndTricksContent,
} from '../../helpers/sub-nav-contexts/sub-nav-context';
import { Flex, Grid, GridItem, Text } from '@patternfly/react-core';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './SubNavTipsAndTricks.scss';
import { faMessagesQuestion } from '@fortawesome/pro-light-svg-icons';
import { useMount } from 'react-use';
import { ZoneSetting, ZoneSettingEnum } from '../../api/zone/ZoneSetting';
import { isJsonObject } from '../util/Helpers';
import Loader from '../util/Loader';

type Props = {
	TipAndTrickPageType?: TipAndTrickPageTypeEnum;
};

const SubNavTipsAndTricks = (props: Props) => {
	const navigate = useNavigate();
	//zs = zone setting
	const [zs_decoded_objects, setZs_decoded_objects] = useState<TipsAndTricksContent[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	useMount(() => {
		getTipsAndTricksZoneSettings();
	});

	useEffect(() => {
		setZs_decoded_objects([]);
	}, [window.location.pathname]);

	const getTipsAndTricksZoneSettings = () => {
		setZs_decoded_objects([]);
		setIsLoading(true);

		if (props.TipAndTrickPageType == TipAndTrickPageTypeEnum.ANALYZE) {
			void Promise.all([
				ZoneSetting.Get(ZoneSettingEnum.analyze_help_1),
				ZoneSetting.Get(ZoneSettingEnum.analyze_help_2),
			]).then(([response1, response2]) => {
				const newItems: TipsAndTricksContent[] = [];

				[response1, response2].forEach((response) => {
					if (response.enabled && isJsonObject(response.value)) {
						const decoded = JSON.parse(response.value) as TipsAndTricksContent;
						newItems.push(decoded);
					}
				});

				setZs_decoded_objects((prevItems) => [...prevItems, ...newItems]);
				setIsLoading(false);
			});
		}

		if (props.TipAndTrickPageType == TipAndTrickPageTypeEnum.DISCOVER) {
			void Promise.all([
				ZoneSetting.Get(ZoneSettingEnum.discover_help_1),
				ZoneSetting.Get(ZoneSettingEnum.discover_help_2),
			]).then(([response1, response2]) => {
				const newItems: TipsAndTricksContent[] = [];

				[response1, response2].forEach((response) => {
					if (response.enabled && isJsonObject(response.value)) {
						const decoded = JSON.parse(response.value) as TipsAndTricksContent;
						newItems.push(decoded);
					}
				});

				setZs_decoded_objects((prevItems) => [...prevItems, ...newItems]);
				setIsLoading(false);
			});
		}

		if (props.TipAndTrickPageType == TipAndTrickPageTypeEnum.PRESENT) {
			void Promise.all([
				ZoneSetting.Get(ZoneSettingEnum.present_help_1),
				ZoneSetting.Get(ZoneSettingEnum.present_help_2),
			]).then(([response1, response2]) => {
				const newItems: TipsAndTricksContent[] = [];

				[response1, response2].forEach((response) => {
					if (response.enabled && isJsonObject(response.value)) {
						const decoded = JSON.parse(response.value) as TipsAndTricksContent;
						newItems.push(decoded);
					}
				});

				setZs_decoded_objects((prevItems) => [...prevItems, ...newItems]);
				setIsLoading(false);
			});
		}

		if (props.TipAndTrickPageType == TipAndTrickPageTypeEnum.REPORT) {
			void Promise.all([
				ZoneSetting.Get(ZoneSettingEnum.report_help_1),
				ZoneSetting.Get(ZoneSettingEnum.report_help_2),
			]).then(([response1, response2]) => {
				const newItems: TipsAndTricksContent[] = [];

				[response1, response2].forEach((response) => {
					if (response.enabled && isJsonObject(response.value)) {
						const decoded = JSON.parse(response.value) as TipsAndTricksContent;
						newItems.push(decoded);
					}
				});

				setZs_decoded_objects((prevItems) => [...prevItems, ...newItems]);
				setIsLoading(false);
			});
		}
	};

	if (isLoading) {
		return <Loader isCustom={true} />;
	}

	return (
		<Grid>
			{zs_decoded_objects.length > 0 && (
				<Grid span={12}>
					<GridItem span={12}>
						<Text>Tips & Tricks</Text>
					</GridItem>
				</Grid>
			)}

			<Grid
				span={12}
				key={'grid-2'}
			>
				{zs_decoded_objects.map((decoded_zs_value, idx) => (
					<GridItem
						span={6}
						key={`tips-and-tricks-grid-item-${idx}`}
					>
						<a
							href={decoded_zs_value.help_url}
							target="_blank"
							rel="noopener noreferrer"
							onClick={(e) => e.stopPropagation()}
						>
							<Grid
								key={`sub-grid-${idx}`}
								className="action-card-container"
							>
								<GridItem
									span={12}
									className="action-card"
									key={`tips-and-tricks-grid-grid-item-${idx}`}
								>
									<Grid>
										<GridItem
											span={10}
											offset={1}
											key={`tips-and-tricks-grid-grid-item-grid-${idx}`}
										>
											<Flex alignItems={{ default: 'alignItemsCenter' }}>
												<Flex
													direction={{ default: 'column' }}
													className="action-card-title"
													flex={{ default: 'flex_4' }}
												>
													<Text className="tutorial-type">
														{decoded_zs_value.help_title}
													</Text>
													<Text className="tutorial-title">
														<a
															href={decoded_zs_value.help_url}
															target="_blank"
															rel="noopener noreferrer"
															onClick={(e) => e.stopPropagation()}
														>
															{decoded_zs_value.help_description}
														</a>
													</Text>
												</Flex>
												<Flex
													alignItems={{ default: 'alignItemsCenter' }}
													className="action-card-icon"
												>
													<FontAwesomeIcon
														size="3x"
														icon={faMessagesQuestion}
													/>
												</Flex>
											</Flex>
										</GridItem>
									</Grid>
								</GridItem>
							</Grid>
						</a>
					</GridItem>
				))}
			</Grid>
		</Grid>
	);
};

export default SubNavTipsAndTricks;
